export default "__VITE_ASSET__D6q$_bTc__"